module.exports = __webpack_public_path__ + "static/media/yunus-mercan.ebd60104.jpg";